import { brandImages } from '../data/brandImages';
import React from 'react';
import { NextStepsCTA } from './NextStepsCTA';
import { Link } from 'react-router-dom';
import { platformUrls } from '../data/mockData';

const CTA = () => {
  return (
    <section className="hbk-closing py-12 lg:py-20 section-dark relative overflow-hidden" data-testid="cta-section">
      <img src={brandImages.progress.src} alt="" aria-hidden="true" loading="lazy" className="hidden md:block absolute inset-0 w-full h-full object-cover object-center opacity-[0.15] pointer-events-none" data-testid="cta-bg-image" />
      <div className="absolute inset-0 pointer-events-none" style={{ background: 'linear-gradient(90deg, rgba(13,27,46,0.96) 0%, rgba(13,27,46,0.75) 55%, rgba(13,27,46,0.45) 100%)' }} />
      <div className="max-w-7xl mx-auto px-4 relative z-10">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8 border-l-2 border-[#dc2626] pl-6 lg:pl-10">
          <div>
            <p className="mono text-sm text-[#fca5a5] mb-3" data-testid="cta-shop-label">
              READY WHEN YOU ARE
            </p>
            <h2 className="section-heading text-white" data-testid="cta-shop-heading">
              Choose Your Next Step
            </h2>
            <p className="text-white text-base mt-4 max-w-xl" data-testid="cta-protocol-note">Start with testing, or bring the results you already have.</p>
          </div>
          <div className="flex flex-col gap-3 shrink-0">
          <Link to="/order"
            className="btn-cta hbk-short-cta self-start lg:self-auto"
            data-testid="cta-customize-btn"
          >
            FIND MY PANEL
          </Link>
          <a href={platformUrls.intake} target="_blank" rel="noopener noreferrer" className="hbk-short-cta text-white underline min-h-[48px] inline-flex items-center" data-testid="cta-protocol-btn">START MY PROTOCOL ↗</a>
          </div>
        </div>
        <NextStepsCTA />
      </div>
    </section>
  );
};

export default CTA;
